const TRAFFIC_CONFIG = {
  SHOW_PHONE_NUMBER: true,
  ATTORNEY_LOAD_TIME: 6000, // in ms
  MAX_NUM_TICKETS: 1,
  MAX_NUM_EVIDENCE: 3 // per ticket
}

export default TRAFFIC_CONFIG
